// extracted by mini-css-extract-plugin
export default {"CoreApp":"CoreApp__t0SJB","MainContent":"MainContent__v1xEj"};